import { Form, Formik, FormikProps } from 'formik'
import { OfferEndBuyers } from '../../../types/flyout'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from './EditOfferEndBuyers.styles'
import { BuyerNotificationForm } from '../BuyerNotificationForm/BuyerNotificationForm'
import { offerEndBuyersValidationSchema } from '../../utils/offerEndBuyersValidation'
import * as Yup from 'yup'

export const EditOfferEndBuyers = ({
  offerEndBuyers,
  handleCloseOfferEndBuyers,
  handleSubmit,
  isUpdateLoading,
}: {
  offerEndBuyers: OfferEndBuyers[]
  handleCloseOfferEndBuyers: () => void
  handleSubmit?: (offerEndBuyers: OfferEndBuyers[]) => void
  isUpdateLoading?: boolean
}) => {
  const { classes } = useStyles()
  const initialValuesOfferEndBuyers = {
    offerEndBuyers: offerEndBuyers,
  }

  const handleSubmitOfferEndBuyers = async (values: {
    offerEndBuyers: OfferEndBuyers[]
  }) => {
    const offerEndBuyersToSend = values?.offerEndBuyers.map(buyer => {
      const { firstName, lastName, email, title } = buyer
      return {
        firstName,
        lastName,
        email,
        title,
      }
    })
    if (handleSubmit) {
      handleSubmit(offerEndBuyersToSend)
    }
  }

  const validationSchema = Yup.object().shape({
    ...offerEndBuyersValidationSchema,
  })

  return (
    <Formik
      initialValues={initialValuesOfferEndBuyers}
      validationSchema={validationSchema}
      validateOnMount={true}
      onSubmit={async values => {
        await handleSubmitOfferEndBuyers(values)
      }}
      enableReinitialize
    >
      {formikProps => {
        const handleSubmit = async () => {
          await formikProps?.submitForm()
        }
        return (
          <Form>
            <BuyerNotificationForm
              formik={
                formikProps as unknown as FormikProps<Record<string, unknown>>
              }
              borderLess
              deleteVisibeForAll={false}
            />
            <div className={classes.rowRightItem}>
              <ButtonV2
                data-testid="cancel-offer-end-buyers"
                smallVariant
                styleType="outlined"
                onClick={handleCloseOfferEndBuyers}
              >
                Cancel
              </ButtonV2>

              <ButtonV2
                data-testid="save-offer-end-buyers"
                smallVariant
                styleType="primary"
                onClick={handleSubmit}
                loading={isUpdateLoading}
              >
                Save
              </ButtonV2>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
